import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import NetworkingEditor from "../../components/layout/NetworkingEditor";
import LeftNav from "../../components/common/LeftNav";
import {useResponsive} from "../../hooks/useResponsive";
import {useThemeMode} from "../../hooks/useThemeMode";
import {useConversation} from "../../hooks/useConversation";

/**
 * Dedicated Networking page component
 * @returns {JSX.Element} The Networking page component
 */
const NetworkingPage = () => {
  const MAX_CONTEXT_TOKENS = 4000; // Adjust based on model's context window
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { isOnPhone, forceClose, navExpanded, toggleNavExpanded } = useResponsive();
  const { isLightMode, toggleModeChange } = useThemeMode();
  const {
    query,
    setQuery,
    responses,
    loadingIndex,
    conversationId,
    detectedGoLinks,
    feedbackSubmitted,
    submittingFeedback,
    totalContextTokens,
    arrowCycle,
    charCount,
    MAX_INPUT_LENGTH,
    latestMessageRef,
    scrollToLatestMessage,
    handleNewConversation,
    handleInputChange,
    handleKeyPress,
    handleSearch,
    handleSearchWithText,
    handleFeedback
  } = useConversation(MAX_CONTEXT_TOKENS);

  const handleNetworkingClick = () => {
    navigate('/networking');
  };


  // Redirect to login if not authenticated
  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
    }
  }, [currentUser, navigate]);

  // Handle closing networking and returning to home
  const handleCloseNetworking = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-row h-screen fixed w-full">
      <LeftNav
        isPhone={isOnPhone}
        isExpanded={navExpanded && !forceClose}
        darkMode={!isLightMode}
        onNewConversation={handleNewConversation}
        onSendPrompt={handleSearchWithText}
        onNetworkingClick={handleNetworkingClick}
      />
      {/* Main Content */}
      <div className="flex-1 h-screen p-2 bg-white transition-all duration-300 dark:bg-black font-Poppins">
        <div className="flex-1 flex flex-col min-h-0 bg-[#f2f2f2] dark:bg-[#1f1f1f] h-full rounded overflow-clip border dark:border-[#2f2f2f] relative">
          {/* Networking Editor */}
          <div className="flex-1 h-full">
            <NetworkingEditor
              isOnPhone={window.innerWidth < 640} // Simple check for mobile
              onClose={handleCloseNetworking}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkingPage;